const formDataSchema = Object.seal({
    feilds: [{
        id: 1,
        name: 'name',
        title: 'Name *',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Name'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 2,
        name: 'gender',
        title: 'Gender *',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Gender'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 3,
        name: 'phonenumber',
        title: 'Phone Number *',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                     var phnoreg = /[6789][0-9]{9}/;
                    return (value !== null && value.length > 0 && value.length < 11 && phnoreg.test(value));
                },
                message: 'Please Enter valid Phone Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 4,
        name: 'unit',
        title: 'Unit *',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Unit'
            }
        ],
        errors: [],
        value: null,
        valid: true,
        state: '',
        disable: false,
        className: 'col-4'
    },{
        id: 5,
        name: 'counselling_stations',
        title: 'Default Counselling Station *',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value !== '' && value !== undefined && value.length > 0 );
                },
                message: 'Please Select Counselling Station'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-4'
    },
    // {
    //     id: 7,
    //     name: 'user_id',
    //     title: 'User ID *',
    //     visible: true,
    //     element: 'input',
    //     required: true,
    //     input_type: 'text',
    //     placeholder: 'Enter',
    //     icon: 'number',
    //     rules: [
    //         {
    //             test: (value) => {
    //                 return (value !== null && value.length > 0)

    //             },
    //             message: 'Please Enter User ID'
    //         }
    //     ],
    //     errors: [],
    //     value: null,
    //     valid: false,
    //     state: '',
    //     disable: false,
    //     className: 'col-4'
    // },
    {
        id: 7,
        name: 'user_id',
        title: 'User ID *',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'text',
        placeholder: 'Enter',
        icon: 'number',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter User ID'
            },
            {
                test: (value) => {
                    // Regular expression to detect special characters
                    const specialCharRegex = /[^a-zA-Z0-9]/;
                    return !specialCharRegex.test(value);
                },
                message: 'User ID should not contain special characters'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },    
     {
        id: 8,
        name: 'password',
        title: 'Password *',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {


                    return (value !== null && value.length > 0);

                },
                message: 'Please Enter Password'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 6,
        name: 'role_id',
        title: 'Role *',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Role'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },
    {
        id: 9,
        name: 'counsellor_type',
        title: 'Counsellor Type *',
        visible: false,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Counsellor Type'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 10,
        name: 'payment',
        title: 'Payment Type *',
        visible: false,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Payment Type'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },{
        id: 11,
        name: 'mapping_unit',
        title: 'Mapping Units*',
        visible: false,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Mapping Units'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },{
        id: 12,
        name: 'nurse_station',
        title: 'Nurse Station ID*',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'text',
        placeholder: 'Enter',
        icon: 'number',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0)

                },
                message: 'Please Enter Nurse Station ID'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },{
        id: 13,
        name: 'mapping_conselling_station',
        title: 'Mapped Counselling stations',
        visible: false,
        element: 'select2multiple',
        required: false,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Mapped Counselling station'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },
    {
        id: 14,
        name: 'mapping_doctor',
        title: 'Mapped Doctors',
        visible: false,
        element: 'select2multiple',
        required: false,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Mapped Doctors'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },
    {
        id: 10,
        name: 'payment1',
        title: 'Payment Type',
        visible: false,
        element: 'select2',
        required: false,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Payment Type'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }
    ]
})

export { formDataSchema };